import {loadRelatedProducts} from './related-products.js'
import {initRelatedProductGalleries} from './related-products-gallery.js';

class CartUpdater {

  constructor({
    template, // 'plp' or 'pdp' depending on where it's called (collection.liquid or product-overview.liquid)
  }) {
    this.template = template;
    this.$html = null;

    this.$collectionSection = null;

    $(() => {
      this.$searchDrawerPopularProducts = $('#search-drawer .popular-products');

      this.$cartDropdownDesktop = $('.cart-dropdown--desktop');
      this.$cartDropdownMobile = $('.cart-dropdown--mobile');
      this.$accountDropdownDesktop = $('.account-dropdown--desktop');
      this.$accountDropdownMobile = $('.account-dropdown--mobile');
  
      this.$gramCounter = $('.gram-counter');
      this.$gramCounterShippingLimit = this.$gramCounter.find('.card--progress-bar');
      this.$gramCounterGramsRemaining = this.$gramCounter.find('.card--grams-remaining');
    });
  }

  /**
   * Allows for buttons to be disabled or enabled, according to the argument.
   * Is called to disable buttons upon invocation of AJAX request,
   * and called again to re-enable them following 'success' of that request.
   *
   * @param {string} status Expects 'enable' or 'disable'. Defaults to 'enable'.
   */
  updateAddToCartButtons(status = 'enable') {
    let $addToCartbuttons = null;
    if ('plp' === this.template) {
      $addToCartbuttons = $('.product__card button[type="submit"]');
    } else if ('pdp' === this.template) {
      $addToCartbuttons = $('.product__card button[type="submit"],#multi-variant-add button#add-to-cart');
    }

    if ($addToCartbuttons.length && 'disable' === status) {
      $addToCartbuttons.prop('disabled', true);
    } else if ($addToCartbuttons.length && 'enable' === status) {
      $addToCartbuttons.prop('disabled', false);
    }
  }

  /**
   * Performs UI updates to indicate a 'pending'/disabled state
   * (the affected 'collection section' (product card row) becomes semi-opaque),
   * and calls method to disable 'Add to Cart' buttons.
   *
   */
  disableCurrentTemplate() {
    if (this.$collectionSection && this.$collectionSection.length) {
      this.$collectionSection.css('opacity', '0.5');
    }

    this.updateAddToCartButtons('disable');
  }

  /**
   * Performs UI updates to indicate an 'activated' state
   * (the affected 'collection section' (product card row) becomes opaque again),
   * and calls method to enable 'Add to Cart' buttons.
   *
   */
  enableCurrentTemplate() {
    if (this.$collectionSection && this.$collectionSection.length) {
      this.$collectionSection.css('opacity', '1');
    }

    this.updateAddToCartButtons('enable');
  }

  /**
   * Replaces the search drawer's Popular Products *contents* (not
   * the element itself) with those found in the returned AJAX data.
   */
  replaceSearchDrawerPopularProducts() {
    const $popularProducts = this.$html.find('#search-drawer .popular-products');

    this.$searchDrawerPopularProducts.html($popularProducts.html());
  }

  /**
   * Replaces the current dropdown menus with those found in the returned AJAX data,
   * then reassigns the current dropdown menus as the new ones.
   *
   */
  replaceCartDropdownMenus() {
    const $cartDropdownDesktopReplacement = this.$html.find('.cart-dropdown--desktop');
    const $cartDropdownMobileReplacement = this.$html.find('.cart-dropdown--mobile');

    this.$cartDropdownDesktop.replaceWith($cartDropdownDesktopReplacement)
    this.$cartDropdownMobile.replaceWith($cartDropdownMobileReplacement)

    this.$cartDropdownDesktop = $cartDropdownDesktopReplacement;
    this.$cartDropdownMobile = $cartDropdownMobileReplacement;
  }

  /**
   * Replaces the current account dropdown with that found in the returned AJAX data,
   * then reassigns the current account dropdown as the new one.
   *
   */
  replaceAccountDropdowns() {
    const $accountDropdownDesktopReplacement = this.$html.find('.account-dropdown--desktop');
    const $accountDropdownMobileReplacement = this.$html.find('.account-dropdown--mobile');

    this.$accountDropdownDesktop.replaceWith($accountDropdownDesktopReplacement)
    this.$accountDropdownMobile.replaceWith($accountDropdownMobileReplacement)

    this.$accountDropdownDesktop = $accountDropdownDesktopReplacement;
    this.$accountDropdownMobile = $accountDropdownMobileReplacement;
  }

  /**
   * Replaces the appropriate gram counter cards with those found in the returned AJAX data,
   * then reassigns the current gram counter cards as the new ones.
   *
   */
  replaceGramCounter() {
    const $gramCounterShippingLimitReplacement = this.$html.find('.card--progress-bar');
    const $gramCounterGramsRemainingReplacement = this.$html.find('.card--grams-remaining');
    const $gramCounter = this.$gramCounterShippingLimit.closest('.gram-counter');

    if ($gramCounter.hasClass('gram-counter--collapsed')) {
      $gramCounterShippingLimitReplacement.css('opacity', '0')
      $gramCounterGramsRemainingReplacement.css('opacity', '0')
    }

    this.$gramCounterShippingLimit.replaceWith($gramCounterShippingLimitReplacement)
    this.$gramCounterGramsRemaining.replaceWith($gramCounterGramsRemainingReplacement)

    this.$gramCounterShippingLimit = $gramCounterShippingLimitReplacement;
    this.$gramCounterGramsRemaining = $gramCounterGramsRemainingReplacement;
  }

  /**
   * Re-assigns dynamic data.
   *
   */
  assignVariables() {
    if ('plp' === this.template) {
      this.$collectionSection = $('#collection-section');
    } else if ('pdp' === this.template) {
      this.$collectionSection = $('.section--related-products .related-products__row');
    } else {
      this.$collectionSection = null;
    }
  }

  /**
   * Re-assigns the class' HTML with that supplied as an argument,
   * provided from the AJAX GET request.
   *
   * @param {string} HTML HTML page data returned by the AJAX get request.
   *
   */
  assignHTML(HTML) {
    this.$html = $(HTML);
  }

  /**
   * Replaces the affected products section on the PLP template,
   * with those found in the HTML of the returned AJAX data.
   *
   */
  replacePLPProducts() {
    const $productsFilter = $('.filter__products');
    const $productsFilterReplacement = this.$html.find('.filter__products');

    $productsFilter.replaceWith($productsFilterReplacement);

  }

  /**
   * Replaces the affected products section on the PDP template,
   * with those found in the HTML of the returned AJAX data.
   *
   * The main product itself doesn't get replaced as the add-to-cart
   * class already manipulates its UI throughout its various events.
   *
   */
  replacePDPProducts() {
    const $relatedProductsTabs = $('.related-products__tabs-wrapper');
    const $relatedProductsTabsReplacement = this.$html.find('.related-products__tabs-wrapper');
    const $relatedProductsTabsReplacementTabPanes = $relatedProductsTabsReplacement.find('.tab-pane');

    if ($relatedProductsTabsReplacementTabPanes.length) {
      $relatedProductsTabsReplacementTabPanes.each((i,el) => {
        const $paneReplacement = $(el);
        const activeClasses = 'show active';
        const $paneToReplace = $relatedProductsTabs.find(`#${$paneReplacement.attr('id')}`);
        if ($paneToReplace.hasClass('active')) {
          $paneReplacement.addClass(activeClasses);
        } else {
          $paneReplacement.removeClass(activeClasses);
        }
        $paneToReplace.replaceWith($paneReplacement);
        initRelatedProductGalleries();
      })
    }

    const $relatedProducts = $('.related-products__fetch');
    if ($relatedProducts.length) {
      loadRelatedProducts();
    }
  }

  /**
   * Prepends or replaces the progress bar on the PLP template.
   *
   */
  toggleProgressBar() {
    const $progressBar = $('.shipping-limit-progress-bar-container');
    const $progressBarReplacement = this.$html.find('.shipping-limit-progress-bar-container');

    if ($progressBar.length) {
      $progressBar.remove();
    }

    if ($progressBarReplacement.length && this.$collectionSection.length) {
      this.$collectionSection.prepend($progressBarReplacement)
    }
  }

  /**
   * Called upon successful AJAX GET request for refreshed page data.
   *
   * Based on the template, calls any methods concerned with updating the
   * template DOM/layout. As initially drafted, this just means replacing
   * product sections with those in the returned page data.
   *
   */
  refreshTemplate() {
    if ('plp' === this.template) {
      const refreshTemplateEvent = new Event("refreshTemplate");
      this.replacePLPProducts();
      document.dispatchEvent(refreshTemplateEvent);
    } else if ('pdp' === this.template) {
      this.replacePDPProducts();
    }
  }

  /**
   * Called upon successful AJAX GET request for refreshed page data.
   *
   * Updates the 'global' (i.e., non-template-dependent) page elements:
   * the cart dropdown menus (desktop, mobile) and the progress bar.
   *
   */
  updateGlobalElements() {
    this.replaceSearchDrawerPopularProducts();
    this.replaceCartDropdownMenus();
    this.replaceAccountDropdowns();
    this.replaceGramCounter();
    // this.toggleProgressBar();
  }

  /**
   * Called upon successful AJAX GET request for refreshed page data.
   *
   * Calls a sequence of methods to handle variable assignments and
   * UI updates.
   *
   * @param {string} HTML HTML page data returned by the AJAX get request.
   *
   */
  triageResponse(HTML) {
    this.assignHTML(HTML);
    this.updateGlobalElements();
    this.refreshTemplate();
  }

  /**
   * Called within add-to-cart-form upon an AJAX form submission.
   *
   * Assigns variables, disables the current template (visually and, re: buttons, literally),
   * and calls AJAX to GET the updated page data, which is then passed along to a 'triage'
   * method, and the current template is re-enabled.
   *
   * @param {string} template expects 'pdp' or 'plp' and is passed from add-to-cart-form, which in turn receives the argument from a corresponding liquid file.
   *
   */
  update(template = null) {
    document.dispatchEvent(new Event('CartUpdater.updating'));

    this.assignVariables(template)
    this.disableCurrentTemplate();

    $.ajax({
      type: "GET",
      url: `${window.location.href}`,
      success: (response) => {
        this.triageResponse(response);
        this.enableCurrentTemplate();
        document.dispatchEvent(new Event('CartUpdater.updated'));
      },
      error: (error) => {
        console.error(error)
      },
      dataType: 'html'
    });
  }
}

// Makes the class available in templates, which is currently leveraged in product-overview.liquid and collection.liquid
window.CartUpdater = CartUpdater;
